import styled from "styled-components";

import { MOBILE_BREAKPOINT } from "../../constants";

// Icon + uppercase-label button used by CreativePanel's tool/popover
// triggers, EndScreenModal's per-marc actions, and gallery / drawing-
// surface download affordances. `$active` flips to the orange-300 fill
// for the popover-open state.
const ActionButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 7px 12px;
  border-radius: 6px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 5px 10px;
    gap: 8px;
  }
  border: 1px solid
    ${(p) =>
      p.$active ? "var(--color-orange-500)" : "var(--color-orange-300)"};
  background: ${(p) =>
    p.$active ? "var(--color-orange-300)" : "var(--color-orange-100)"};
  color: var(--color-text);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  cursor: pointer;
  transition:
    background-color 120ms ease-out,
    border-color 120ms ease-out,
    transform 60ms ease-out;

  &:hover {
    background: var(--color-orange-300);
    border-color: var(--color-orange-400);
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export default ActionButton;
